import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NoDataAvailable from "../../../components/NoDataAvailable/NoDataAvailable";

const DetailsTabAgenda = ({ agenda }) => {
  return (
    <Grid item md={12}>
      <Accordion
        className="accordion"
        sx={{
          "&.MuiAccordion-root.Mui-expanded:last-of-type": {
            marginBottom: "1rem",
          },
        }}
      >
        <AccordionSummary
          className="accordion-summary"
          sx={{ height: "3.938rem !important" }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="font_15_bold_600">Agenda</Typography>
        </AccordionSummary>
        <AccordionDetails className="accordion-details">
          {agenda?.length ? (
            <Box className="agenda-details">
              <div dangerouslySetInnerHTML={{ __html: agenda }} />
            </Box>
          ) : (
            <Grid container className="no-data-container">
              <NoDataAvailable
                imgHeight={4}
                imgWidth={4.5}
                message="No Agenda Available"
              />
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default DetailsTabAgenda;
